import { NodeApi, TextApi, type Descendant } from 'platejs';

export const transformRichTextToString = (
  nodes: Descendant[],
  typeResolver?: { type: string; resolveTo: (node: Descendant) => string }[],
): string =>
  nodes
    .map((n) => {
      if (TextApi.isText(n)) {
        return NodeApi.string(n);
      }

      const resolver = typeResolver?.find(({ type }) => n.type === type);
      if (resolver) {
        return resolver.resolveTo(n);
      }

      return transformRichTextToString(n.children, typeResolver);
    })
    .join('');
